<template>
    <div
        class="ag-cell-label-container"
        :class="classes"
        role="presentation"
        :title="columnHeaderText"
    >
        <div
            ref="eLabel"
            class="ag-header-cell-label"
            role="presentation"
        >
            <span
                v-if="displayName"
                ref="eText"
                class="ag-header-cell-text"
                role="columnheader"
            >
                {{ columnHeaderText }}

                <TooltipHelp
                    v-if="tooltiptext"
                    :text="tooltiptext"
                ></TooltipHelp>
            </span>
            <slot></slot>
        </div>
    </div>
</template>

<script setup lang="ts" generic="TRowData, TCell = any">
import { TooltipHelp } from '@/components';
import type { IGridCompExposed } from '../Classes';
import type { IHeaderComponentParamsColumn } from '../Classes/params/IHeaderComponentParamsColumn';
import { computed } from 'vue';
import { $tm } from '@/locize';
import type { IGridStandardHeaderParams } from '../Classes/IGridStandardHeaderParams';

const props = defineProps<
    {
        grid: IGridCompExposed<TRowData>;
        column: IHeaderComponentParamsColumn;
    } & IGridStandardHeaderParams
>();

const columnHeaderText = computed(() => {
    if (!props.displayName) {
        return '';
    }
    return $tm(props.displayName);
});
</script>
